import editorModelToHtml from "@/helpers/quill/editorModelToHtml";
import editorModelToText from "@/helpers/quill/editorModelToText";
import getEmptyEditorModel from "@/helpers/quill/getEmptyEditorModel";
import htmlToEditorModel from "@/helpers/quill/htmlToEditorModel";

export default {
  editorModelToHtml,
  editorModelToText,
  getEmptyEditorModel,
  htmlToEditorModel,
};
